import { AfterViewInit, Component, Input, OnInit } from '@angular/core'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { NewsService } from '../../services/news.service'

@Component({
  selector: 'recent-news',
  templateUrl: './recent-news.component.html',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
],
  styleUrl: './recent-news.component.css'
})
export class RecentNewsComponent implements OnInit {
  private _news: any[] = []
  showTitle = false

  @Input() set news(value: any[]) {
    if (!value || value.length === 0) {
      this._news = []
    } else {
      this._news = value
    }
  }

  get news() {
    return this._news
  }
  
  constructor(
    public service: NewsService,
    private router: Router
  ) {}

  
  ngOnInit() {
    if (!this.news || this.news.length === 0) {
      this.service.fetchNews().subscribe(news => {
        this._news = (news as any[])
        .slice(0, 5)
      })
    }
    if(this.router.url === '/home') this.showTitle = true
  }
}